import { useRef } from 'react';
import { useReferencedFn } from './useReferencedFn.js';

function useSingletonRef(factory) {
  const ref = useRef(null);
  const factoryRef = useReferencedFn(factory);
  if (ref.current === null) ref.current = factoryRef.current();
  return ref;
}

export { useSingletonRef };
//# sourceMappingURL=useSingletonRef.js.map
